<template>
  <patient-pie-analysis
    title="LINE會員語系圓餅圖"
    :data="sourceData"
  />
</template>

<script>
import { getAnalysisLineLangAPI } from "../../api";
import { mapGetters } from "vuex";
import PatientPieAnalysis from "./PatientPieAnalysis.vue";
import { generateRandomColor } from "../../utils/tool";

export default {
  name: "LineLangAnalysis",

  components: {PatientPieAnalysis},

  data() {
    return {
      sourceData: null,
      colorSetting: {
        zh: '#838181',
        en: '#23bfda',
        ja: '#efcf13',
        th: '#f45d64'
      }
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData',
    ]),
  },

  methods: {
    getAnalysisData() {
      getAnalysisLineLangAPI(this.axiosParamData).then(res => {
        const data = res.data
        data.datasets[0].backgroundColor = this.colorTheme(data.labels)
        this.sourceData = res.data
      })
    },
    colorTheme(labels) {
        return labels.map(label => this.colorSetting[label] || generateRandomColor())
    }
  },

  mounted() {
    this.getAnalysisData()
  }
}
</script>

<style scoped>

</style>
